import React, { useEffect, useState } from "react";
import Header from "../utils/Header";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Pagination from "@mui/material/Pagination";

const ReportPage = ({ supabase, session, handleLogout }) => {
  const [fightsWithFeelings, setFightsWithFeelings] = useState([]);
  const [totalNumberofFights, setTotalNumberOfFights] = useState(0);
  const [fightsPerPage] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);

  useEffect(() => {
    get_total_number_of_fights();
  }, []);

  useEffect(() => {
    console.log("Setting Number Of Pages totalNumberofFights==" + totalNumberofFights);
    console.log("Setting Number Of Pages fightsPerPage==" + fightsPerPage);
    setNumberOfPages(Math.ceil(totalNumberofFights/fightsPerPage));
  }, [totalNumberofFights]);

  useEffect(() => {
    get_fights_per_page();
  }, [totalNumberofFights, pageNumber]);

  const get_total_number_of_fights = async () => {
    const { count, error } = await supabase.from("fight").select("*", { count: "exact", head: true }).eq("user_id", session.user.id);
    setTotalNumberOfFights(count);
  };

  const get_fights_per_page = async () => {
    const { data } = await supabase
      .from("fight")
      .select(
        `
          fight_id,
          topic,
          category,
          resolved,
          start_date,
          fights (
            id,
            feeling,
            start_date,
            fight_id
          )
        `
      )
      .eq("user_id", session.user.id)
      .range(((pageNumber - 1) * fightsPerPage), ((pageNumber * fightsPerPage) - 1));

    console.log("Report Page Fetched fights data:", data);
    setFightsWithFeelings(data);
  };

  const handlePageChange = (event, value) => {
    setPageNumber(value);
  };

  return (
    <div style={{ fontFamily: "lato", margin: "10px" }}>
      <Header session={session} handleLogout={handleLogout} />
      <div>
        {fightsWithFeelings.map((fight) => (
          <div
            key={fight.fight_id}
            style={{
              margin: "10px",
              borderBottom: "2px solid #a6a6a6",
              background: "#fffefe",
              boxShadow: "0 8px 8px -4px #ff7885",
              padding: "10px",
            }}
          >
            <Accordion>
              <AccordionSummary>
                <div>
                  <strong>{fight.topic || `Fight on ${fight.start_date}`}</strong>
                  <br />
                  {fight.fights?.length > 0 ? (
                    <>
                      Feelings recorded: {fight.fights.length} <br />
                      Reason for Fight: {fight.category}
                    </>
                  ) : (
                    "No feelings recorded"
                  )}
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <ul>
                  {fight.fights.map((f) => (
                    <li key={f.id}>
                      Feeling: {f.feeling}, Date: {f.start_date}
                    </li>
                  ))}
                </ul>
              </AccordionDetails>
            </Accordion>
          </div>
        ))}
      </div>

      <Pagination count={numberOfPages} page={pageNumber} onChange={handlePageChange} />
    </div>
  );
};

export default ReportPage;
